export default __webpack_public_path__ + "static/media/sports11.b57d2e65.jpg";